import { render, staticRenderFns } from "./UserListBlock.vue?vue&type=template&id=05497392&scoped=true"
import script from "./UserListBlock.vue?vue&type=script&lang=js"
export * from "./UserListBlock.vue?vue&type=script&lang=js"
import style0 from "./UserListBlock.vue?vue&type=style&index=0&id=05497392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05497392",
  null
  
)

export default component.exports